import axios from 'axios';

let userTimezone = ''

export const setUserTimezone = (tmz = '') => {
    userTimezone = typeof tmz === 'string' ? tmz : ''
}

const http = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Optionally, add request/response interceptors
http.interceptors.request.use(
    (config) => {
        const toHeaderTimezoneFormat = (tz) => {
            if (!tz || typeof tz !== 'string') return ''

            const normalized = tz.trim().toUpperCase()

            // Accept values like "GMT+13", "UTC-3", "+13", "-3", "+13:00"
            const match = normalized.match(/(?:GMT|UTC)?\s*([+-])\s*(\d{1,2})(?::?(\d{2}))?/)
            if (!match) return ''

            const sign = match[1]
            const hours = Number(match[2])
            const minutes = Number(match[3] || '0')

            if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return ''

            const offsetHours = hours + (minutes / 60)
            return `${sign},${offsetHours}`
        }

        // Prefer server-provided user timezone if available, otherwise use client offset fallback.
        let timezoneHeader = ''
        if (userTimezone) {
            timezoneHeader = toHeaderTimezoneFormat(userTimezone)
        }

        if (!timezoneHeader) {
            const timezoneOffsetMinutes = new Date().getTimezoneOffset();
            timezoneHeader = `${timezoneOffsetMinutes <= 0 ? '+' : '-'},${Math.abs(timezoneOffsetMinutes / 60)}`;
        }

        config.headers['X-Client-Timezone'] = timezoneHeader
        
        const token = localStorage.getItem('token') ?? ''
        if (token) config.headers.Authorization = `Bearer ${token}`

        return config;
    },
    (error) => Promise.reject(error)
);

http.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;
    
        if (status === 401) {
          setUserTimezone('')
          if (localStorage.getItem('token')) {
            localStorage.removeItem('token');
            window.location.href = '/login';
          }else{
            localStorage.removeItem('token');
          }
        }
    
        console.error('Axios Error:', error.response || error.message);
        return Promise.reject(error);
    }
);

export default http